export const NAV = {
  brand: "nav-brand",
  links: "nav-links",
  cta: "nav-cta",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  heading: "hero-heading",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const ABOUT = {
  section: "about-section",
  founderKetan: "founder-ketan",
  founderSanyam: "founder-sanyam",
  founderRiddhi: "founder-riddhi",
};

export const PROCESS = {
  section: "process-section",
  step: "process-step",
};

export const CHART = {
  section: "chart-section",
  toggle: "chart-toggle",
};

export const CALC = {
  hub: "calculators-hub",
  sipCard: "sip-card",
  lumpsumCard: "lumpsum-card",
  goalCard: "goal-card",
  stepUpCard: "stepup-card",
  // SIP
  sipAmount: "sip-amount",
  sipYears: "sip-years",
  sipRate: "sip-rate",
  sipResult: "sip-result",
  // Lumpsum
  lumpAmount: "lump-amount",
  lumpYears: "lump-years",
  lumpRate: "lump-rate",
  lumpResult: "lump-result",
  // Goal
  goalAmount: "goal-target",
  goalYears: "goal-years",
  goalRate: "goal-rate",
  goalResult: "goal-result",
  // Step-up
  stepAmount: "step-amount",
  stepYears: "step-years",
  stepRate: "step-rate",
  stepIncrement: "step-increment",
  stepResult: "step-result",
};

export const QUIZ = {
  start: "quiz-start",
  option: "quiz-option",
  next: "quiz-next",
  result: "quiz-result",
  restart: "quiz-restart",
  submitName: "quiz-submit-name",
  nameInput: "quiz-name-input",
};

export const GOAL_CARDS = {
  section: "goal-cards-section",
  card: "goal-card-item",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  goal: "contact-goal",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
};

export const WHATSAPP = {
  fab: "whatsapp-fab",
};

export const FOOTER = {
  root: "site-footer",
};

export const JOURNEY = {
  section: "investment-journey",
  slider: "journey-slider",
};
